import type { OpeningHours as OpeningHoursOldType } from 'app/components/commons/Hotel/Types';
import type { PresetOpeningHours } from 'app/components/commons/TimeRangeSection/TimeRangeSection';
import { parseOpeningHoursFromAPI } from 'app/components/commons/TimeRangeSection/utils';
import type { Space } from 'app/redux/models/Space/Space';
import type { SpaceType } from 'app/redux/models/SpaceType/SpaceType';
import { dayjs } from 'app/utils/dayjs';
import type { Dayjs } from 'app/utils/dayjs';

export const DEFAULT_SLOT = { start: '09:00', end: '18:00' };

export const presetOpeningHours = (
  spaces?: Space[],
  spaceIds?: number[],
  spaceTypes?: SpaceType[]
) => {
  const filterSpaceOpeningHours = (space: Space) =>
    space.id && spaceIds?.includes(space.id);

  const filterUndefined = (o: {
    name: string | undefined;
    openingHours: OpeningHoursOldType | undefined;
  }): o is PresetOpeningHours =>
    o.name !== undefined && o.openingHours !== undefined;

  const getName = (space: Space) =>
    space.name && space.name.trim().length > 0
      ? space.name
      : spaceTypes?.find((s) => s.id === space.spaceTypeId)?.name;

  return (
    spaces
      ?.filter(filterSpaceOpeningHours)
      .map((hs) => ({
        name: getName(hs),
        openingHours: parseOpeningHoursFromAPI(
          hs.openingHours
        ) as unknown as OpeningHoursOldType,
      }))
      .filter(filterUndefined) ?? []
  );
};

export const formatToDayjs = (slot: { start: string; end: string }) => [
  dayjs(slot.start, 'HH:mm'),
  dayjs(slot.end, 'HH:mm'),
];

export const formatDayjsToTimeRange = (
  dayjsRange: [Dayjs, Dayjs] | null
): { start: string; end: string } | null => {
  if (!dayjsRange) {
    return null;
  }

  return {
    start: dayjsRange[0].format('HH:mm'),
    end: dayjsRange[1].format('HH:mm'),
  };
};
